import { render, staticRenderFns } from "./CategoryTab.vue?vue&type=template&id=71ff480b&scoped=true&"
import script from "./CategoryTab.vue?vue&type=script&lang=js&"
export * from "./CategoryTab.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTab.vue?vue&type=style&index=0&id=71ff480b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ff480b",
  null
  
)

export default component.exports